<template>
  <div class="fankit-page-container">
    <div class="fankit-page-content">
      <div v-if="pageButtonShow" class="fankit-page--pre" :class="{ 'fankit-page--hide': pageNum <= 1 }"
        @click="pagePre">&lt;&lt;</div>

      <div class="fankit-page--num">
        <span class="fankit-page--num-min" v-show="minNumShow" @click="jumpPage(1)">1</span>
        <span class="fankit-page--more" v-show="minNumShow" @click="minMore">...</span>

        <span v-for="(item, index) in curPageArr" :key="`fankit-page--num-${index}`"
          :class="[`fankit-page--num-${index}`, { 'fankit-page--num-active': curPageArr[index] == pageNum }]"
          @click="jumpPage(curPageArr[index])">{{ $utils.prefixNum(curPageArr[index]) }}</span>

        <span class="fankit-page--more" v-show="maxNumShow" @click="maxMore">...</span>
        <span class="fankit-page--num-max" v-show="maxNumShow" @click="jumpPage(totalPageNum)">{{ totalPageNum }}</span>
      </div>

      <div v-if="pageButtonShow" class="fankit-page--next" :class="{ 'fankit-page--hide': pageNum >= totalPageNum }"
        @click="pageNext">&gt;&gt;
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Pagination",
  props: {
    totalPageNum: Number,    // 总页数
    maxPageNum: Number,      // 当前显示的页码数
    curPageNum: Number,      // 当前页数
    pageButtonShow: Boolean   // 上下按钮是否显示
  },
  components: {

  },
  data() {
    return {
      pageNum: this.curPageNum,      // 当前页数
      rightNum: 0,                // 当前右边界
      leftNum: 0,                 // 当前左边界
    }
  },
  created() {
  },
  mounted() {

  },
  watch: {
    curPageNum(val) {
      this.pageNum = val
    },
    pageNum(val, oldVal) {
      // update为固定字段，通过冒号连接双向绑定的curPageNum，将curPageNum传递给父组件v-model绑定的变量
      this.$emit("update:curPageNum", val)
    },
  },
  computed: {
    curPageArr() {      // 显示的页码
      let arr = []
      const maxNum = Math.min(this.totalPageNum, this.maxPageNum)

      this.leftNum = this.pageNum - (Math.ceil(maxNum / 2) - 1)        // 当前左边界
      this.rightNum = this.pageNum + (Math.floor(maxNum / 2))        // 当前右边界
      // console.log(`leftNum: ${leftNum}, rightNum: ${rightNum}`)

      if (this.leftNum < 1) {
        this.leftNum = 1
        for (let i = this.leftNum; i < this.leftNum + maxNum; i++) {
          arr.push(i)
        }

      } else if (this.rightNum > this.totalPageNum) {
        this.rightNum = this.totalPageNum
        for (let i = this.rightNum - maxNum + 1; i <= this.rightNum; i++) {
          arr.push(i)
        }
      } else {
        for (let i = this.leftNum; i < this.leftNum + maxNum; i++) {
          arr.push(i)
        }
      }
      return arr
    },
    maxNumShow() {
      if (this.totalPageNum >= 7) {
        if (this.rightNum < this.totalPageNum - 1) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    minNumShow() {
      if (this.totalPageNum >= 7) {
        if (this.leftNum > 1 + 2) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    }
  },
  methods: {
    pagePre() {
      if (this.pageNum <= 1) {
        return false
      }
      this.pageNum--
    },
    pageNext() {
      if (this.pageNum >= this.totalPageNum) {
        return false
      }
      this.pageNum++
    },
    jumpPage(num) {
      this.pageNum = num
      this.$emit("jumpPage", num)
    },
    maxMore() {
      this.pageNum = this.rightNum + 1
      this.$emit("jumpPage", this.pageNum)
    },
    minMore() {
      this.pageNum = this.leftNum - 1
      this.$emit("jumpPage", this.pageNum)
    },
  },
};
</script>

<style lang="scss" scoped>
.fankit-page-container {
  width: auto;
  height: 100%;
  display: flex;
  justify-content: center;

  .fankit-page-content {
    width: auto;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .fankit-page--pre {
      font-size: pxTorem(20px);
      cursor: pointer;
      width: pxTorem(45px);
      height: pxTorem(45px);
      line-height: pxTorem(45px);
      text-align: center;
      color: #989898;
      @include userSelect;

      &.fankit-page--hide {
        opacity: 0;
      }
    }

    .fankit-page--num {
      width: auto;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-evenly;

      span {
        width: pxTorem(43px);
        height: pxTorem(43px);
        border: 1px solid #22bbff;
        box-sizing: border-box;
        text-align: center;
        line-height: pxTorem(43px);
        color: #fff;
        font-size: pxTorem(16px);
        cursor: pointer;
        transition: all .1s ease-in-out;
        
        &:not(:last-child) {
          margin-right: pxTorem(15px);
        }
      
        &:hover {
          background: #22bbff;
          color: #000;
        }
      }

      .fankit-page--num-active {
        background: #22bbff;
        color: #000;
      }
    }

    .fankit-page--next {
      font-size: pxTorem(20px);
      width: pxTorem(45px);
      height: pxTorem(45px);
      line-height: pxTorem(45px);
      cursor: pointer;
      text-align: center;
      color: #989898;
      @include userSelect;

      &.fankit-page--hide {
        opacity: 0;
      }
    }
  }
}
</style>